module.exports = __webpack_public_path__ + "img/Sentiments.e900cb78.svg";